import { useEffect, useState, useMemo } from "react";
import { api } from "../lib/api";
import { EpisodeCard } from "../components/Cards";

export default function Episodes() {
  const [episodes, setEpisodes] = useState([]);
  const [filter, setFilter] = useState("All");

  useEffect(() => {
    api.get("/episodes").then((r) => setEpisodes(r.data));
  }, []);

  const industries = useMemo(() => {
    const set = new Set(episodes.map((e) => e.industry));
    return ["All", ...Array.from(set)];
  }, [episodes]);

  const filtered = filter === "All" ? episodes : episodes.filter((e) => e.industry === filter);

  return (
    <div data-testid="episodes-page" className="max-w-[1400px] mx-auto px-6 lg:px-10 pt-32 pb-24">
      <div className="mb-16 reveal">
        <p className="eyebrow mb-4">The Library</p>
        <h1 className="font-display text-6xl md:text-7xl mb-6">Interviews & Documentaries</h1>
        <p className="text-lg max-w-2xl leading-relaxed" style={{ color: "var(--ink-muted)" }}>
          Long-form conversations with the magnates, stewards, and quiet operators of modern wealth.
        </p>
      </div>

      <div className="flex flex-wrap gap-3 mb-12 pb-6" style={{ borderBottom: "1px solid var(--hairline)" }}>
        {industries.map((i) => (
          <button
            key={i}
            data-testid={`filter-${i.toLowerCase().replace(/\s+/g, "-")}`}
            onClick={() => setFilter(i)}
            className="text-xs uppercase tracking-[0.2em] px-4 py-2 transition-colors duration-300"
            style={{
              border: "1px solid",
              borderColor: filter === i ? "var(--brass)" : "var(--hairline)",
              color: filter === i ? "var(--brass)" : "var(--ink-muted)",
            }}
          >
            {i}
          </button>
        ))}
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10">
        {filtered.map((ep) => (
          <EpisodeCard key={ep.id} ep={ep} />
        ))}
      </div>

      {filtered.length === 0 && (
        <p className="text-center py-20" style={{ color: "var(--ink-muted)" }}>No interviews in this category yet.</p>
      )}
    </div>
  );
}
